<template>
  <div ref="holder" :class="{'deleting': isDelete() }" style="height:100%; width:100%; overflow:hidden; position:relative">

    <svg ref="canvasSvgBg" viewBox="0 0 1000 1000" :style="{'transform': 'translate(' + -transformX + 'px, ' + -transformY + 'px) scale(' + scaleBg + ')', 'position': 'absolute'}"> </svg>
    <svg ref="canvasSvg" @touchmove="onTouchmove" @touchstart="onTouchStart" @touchend="onTouchEnd" @wheel.prevent="onWheel" @mousedown="onMousedown" @mouseup="onMouseup" @mousemove="onMousemove" viewBox="0 0 1000 1000" :style="{'transform': 'translate(' + -transformX + 'px, ' + -transformY + 'px) scale(' + scale + ')'}">

      <polygon points="0,0 1000,0 1000,1000 0,1000" style="fill:whitesmoke;stroke:darkgrey;stroke-width:1" />
      <defs>
        <pattern id="smallGrid" width="1" height="1" patternUnits="userSpaceOnUse">
          <g>
            <path d="M 1 0 L 0 0 0 1" fill="none" stroke="lightgrey" stroke-width="0.05"/>
            <path d="M 0.5 1 L 0.5 0" fill="none" stroke="#E3E3E3" stroke-width="0.02"/>
            <path d="M 0 0.5 L 1 0.5" fill="none" stroke="#D3D3D3" stroke-width="0.02"/>
          </g>
        </pattern>
        <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
          <rect width="10" height="10" fill="url(#smallGrid)"/>
          <path d="M 10 0 L 0 0 0 10" fill="none" stroke="lightgrey" stroke-width="0.1"/>
        </pattern>
      </defs>

      <rect :opacity="isEdit ? 1 : 0.25" width="100%" height="100%" fill="url(#grid)" />

      <polygon
        v-for="(polygon, index) of polygons" :key="'poly' + index"
        @click="deletePolygon(polygon)"
        class="polygon" :points="polygon.points.map(p => p.svgPoint).join(' ')"  style="fill:rgb(100 100 100 / 11%);stroke:rgb(170, 170, 170);stroke-width:0.1"  stroke-linejoin="round" />

      <polyline @click="deleteDivider(divider)" class="divider" v-for="(divider, index) of dividers" :key="'divider' + index"
        fill="none"
        stroke="rgb(170, 170, 170)"
        stroke-width="0.1"
        stroke-linejoin="round"
        v-bind:points="divider.map(p => p.svgPoint).join(' ')"/>

      <polyline v-if="this.drawMode && drawMode.polygon && drawMode.polygon.points"
        fill="none"
        stroke="#0074d9"
        stroke-width="0.1"
        stroke-linejoin="round"
        v-bind:points="drawMode.polygon.points.map(p => p.svgPoint).join(' ')"/>

      <g
        @click="deleteText(text)"
        @mouseover="elementMouseOver($event, text.rotation, text)"
        @mouseleave="elementMouseLeave($event)"
        v-for="(text, index) of labels" class="text editable" :key="'textBackground' + index" :transform="'translate(' + text.x + ' ' + text.y + ') rotate(' + text.rotation + ')'">

        <text letter-spacing="0.02" :font-size="text.fontSize + 'px'" text-anchor="middle" style="font-family: 'Montserrat', Helvetica, Arial, sans-serif; sans-serif; font-weight: 500;
          fill: rgba(255 255 255 / 15%);
          stroke: rgba(255 255 255 / 15%);
          stroke-width: 0.12;">
          {{text.text}}</text>
        <text :key="'text' + index" letter-spacing="0.02" text-anchor="middle" :font-size="text.fontSize + 'px'" style="font-family: 'Montserrat', Helvetica, Arial, sans-serif; sans-serif; font-weight:500; fill:rgb(80, 80, 80)">{{text.text}}</text>
      </g>

      <g
        @mouseover="elementMouseOver($event, table.rotation, table)"
        @mouseleave="elementMouseLeave($event)"
        @click="clickTable(table)" v-for="(table, index) of tables.filter(t => !t.hidden)" :key="'table'+ index" :transform="'translate(' + table.x + ' ' + table.y + ') rotate(' + (table.table.isRoundTable ? '0' : table.rotation) + ')'">
        <circle v-for="(seat, seatIndex) of table.seats"   :key="'table'+ index + 'seat' + seatIndex" :cx="seat.x + 0.135" :cy="seat.y" :r="0.25" fill="rgba(100 100 100 / 80%)" stroke="rgb(120 120 120)" stroke-width="0.025"></circle>
        <polygon v-if="table.seats.length > 1 && !table.table.isRoundTable"  class="table-polygon" :points="'0.135,0 ' + (table.width + 0.135)+',0 ' + (table.width + 0.135)+','+table.height + ' 0.135,'+table.height"  :fill="table.status.color" :stroke="table.status.color" stroke-width="0.15" stroke-linejoin="round"/>
        <circle v-if="table.seats.length > 1 && table.table.isRoundTable"  class="table-polygon" :cx="0 + 0.135" :cy="0" :r="table.width/2"  :fill="table.status.color" />
        <!--Text for rectangular tables-->
        <text v-if="!table.table.isRoundTable" :transform="table.rotation > 90 && table.rotation <= 270 ? 'rotate(180) translate(' + (-table.width * 1 - .135 * 2) + ',' + (-table.height) + ')' : 'rotate(0)'" :x="table.width * 0.5 +  + 0.135" :y="seatingGap*(table.status.subLabel ? 0.35 : 0.5) + 0.075" letter-spacing="0.02" text-anchor="middle" :fill="table.status.color" :stroke="table.status.color" style="font-size:0.25px; font-family: 'Montserrat', Helvetica, Arial, sans-serif; sans-serif; font-weight:900; pointer-events:none; stroke-width: 0.1;" >{{table.table.name}}</text>
        <text v-if="!table.table.isRoundTable" :transform="table.rotation > 90 && table.rotation <= 270 ? 'rotate(180) translate(' + (-table.width * 1 - .135 * 2 ) + ',' + (-table.height) + ')' : 'rotate(0)'" :x="table.width * 0.5 +  + 0.135" :y="seatingGap*(table.status.subLabel ? 0.35 : 0.5) + 0.075" letter-spacing="0.02" text-anchor="middle" style="font-size:0.25px; font-family: 'Montserrat', Helvetica, Arial, sans-serif; sans-serif;fill:rgb(255 255 255 / 80%); font-weight:800; pointer-events:none">{{table.table.name}}</text>
        <text v-if="!table.table.isRoundTable && table.status.subLabel" :transform="table.rotation > 90 && table.rotation <= 270 ? 'rotate(180) translate(' + (-table.width * 1 - .135 * 2) + ',' + (-table.height) + ')' : 'rotate(0)'" :x="table.width * 0.5 +  + 0.135" :y="seatingGap*0.65 + 0.075" letter-spacing="0.02" text-anchor="middle" :fill="table.status.color" :stroke="table.status.color" style="font-size:0.25px; font-family: 'Montserrat', Helvetica, Arial, sans-serif; sans-serif; font-weight:900; pointer-events:none; stroke-width: 0.1;" >{{table.status.subLabel}}</text>
        <text v-if="!table.table.isRoundTable && table.status.subLabel" :transform="table.rotation > 90 && table.rotation <= 270 ? 'rotate(180) translate(' + (-table.width * 1 - .135 * 2 ) + ',' + (-table.height) + ')' : 'rotate(0)'" :x="table.width * 0.5 +  + 0.135" :y="seatingGap*0.65 + 0.075" letter-spacing="0.02" text-anchor="middle" style="font-size:0.25px; font-family: 'Montserrat', Helvetica, Arial, sans-serif; sans-serif;fill:rgb(255 255 255 / 80%); font-weight:800; pointer-events:none">{{table.status.subLabel}}</text>
        <!--Text for round tables-->
        <text v-if="table.table.isRoundTable" :x="0.135" :y="seatingGap*(table.status.subLabel ? -0.2 : 0) + 0.075" letter-spacing="0.02" text-anchor="middle" :fill="table.status.color" :stroke="table.status.color" style="font-size:0.25px; font-family: 'Montserrat', Helvetica, Arial, sans-serif; sans-serif; font-weight:900; pointer-events:none; stroke-width: 0.1;" >{{table.table.name}}</text>
        <text v-if="table.table.isRoundTable" :x="0.135" :y="seatingGap*(table.status.subLabel ? -0.2 : 0) + 0.075" letter-spacing="0.02" text-anchor="middle" style="font-size:0.25px; font-family: 'Montserrat', Helvetica, Arial, sans-serif; sans-serif;fill:rgb(255 255 255 / 80%); font-weight:800; pointer-events:none">{{table.table.name}}</text>
        <text v-if="table.table.isRoundTable && table.status.subLabel" :x="0.135" :y="seatingGap*0.2 + 0.075" letter-spacing="0.02" text-anchor="middle" :fill="table.status.color" :stroke="table.status.color" style="font-size:0.25px; font-family: 'Montserrat', Helvetica, Arial, sans-serif; sans-serif; font-weight:900; pointer-events:none; stroke-width: 0.1;" >{{table.status.subLabel}}</text>
        <text v-if="table.table.isRoundTable &&table.status.subLabel" :x="0.135" :y="seatingGap*0.2 + 0.075" letter-spacing="0.02" text-anchor="middle" style="font-size:0.25px; font-family: 'Montserrat', Helvetica, Arial, sans-serif; sans-serif;fill:rgb(255 255 255 / 80%); font-weight:800; pointer-events:none">{{table.status.subLabel}}</text>
      </g>

      <g
          @mouseover="elementMouseOver($event, icon.rotation, icon)"
          @mouseleave="elementMouseLeave($event)"
          @click="deleteIcon(icon)" v-for="(icon, index) of icons" class="icon-group" :key="'icon'+index" :transform="'translate(' + icon.x + ' ' + icon.y + ') rotate(' + icon.rotation + ')'" >

        <rect :width="icon.iconSize" :height="icon.type === iconTypes.Window ? 0.25 : icon.iconSize" style="fill:rgba(0,0,0,0.0);stroke-width:0;stroke:rgb(0,0,0)" />
        <svg v-if="icon.type === iconTypes.RestroomUnisex" style="fill: rgb(100, 100, 100); pointer-events: auto;" :width="icon.iconSize" :height="icon.iconSize" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg"><path d="M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"/></svg>
        <svg v-if="icon.type === iconTypes.Wardrobe" style="fill: rgb(100, 100, 100); pointer-events: auto;" :width="icon.iconSize" :height="icon.iconSize" viewBox="0 0 468.765 334.905" xmlns="http://www.w3.org/2000/svg"><defs id="defs3823"><marker id="ArrowEnd" markerHeight="3" markerUnits="strokeWidth" markerWidth="4" orient="auto" refX="0" refY="5" viewBox="0 0 10 10"><path d="M 0 0 L 10 5 L 0 10 z" id="path3826"/></marker><marker id="ArrowStart" markerHeight="3" markerUnits="strokeWidth" markerWidth="4" orient="auto" refX="10" refY="5" viewBox="0 0 10 10"><path d="M 10 0 L 0 5 L 10 10 z" id="path3829"/></marker></defs><g id="g3831"><path d="M 20.5798 251.652C 0.890778 263.269 -2.66223 288.001 1.60777 303.006C 5.74977 317.558 20.3498 334.905 46.6228 334.905L 46.6818 334.905C 46.6818 334.905 385.442 334.905 419.603 334.905C 449.02 334.905 462.434 318.042 466.575 303.49C 470.845 288.485 470.845 265.251 448.071 251.214L 250.58 134.652L 250.58 114.806C 250.58 92.298 226.026 82.527 226.026 82.527C 210.133 74.782 211.556 58.084 211.556 58.084C 211.556 38.482 229.111 32.189 236.937 32.189C 250.08 32.189 262.969 39.477 264.329 56.148C 266.465 82.286 296.08 75.652 296.08 54.652C 296.08 34.808 277.979 0 236.701 0C 192.08 0 179.264 43.629 179.264 57.424C 179.264 67.829 180.909 77.437 187.33 88.402C 198.242 107.037 220.08 109.966 220.08 122.308L 220.08 134.652L 20.5798 251.652z" id="path3833" style="stroke:none; fill:rgb(80, 80, 80)"/><path d="M 234.092 164.574L 427.58 277.652C 439.58 286.152 433.08 302.152 420.08 302.179L 47.2148 302.179C 35.0798 302.652 27.5798 285.652 39.5798 278.152L 234.092 164.574z" id="path3835" style="stroke:none; fill:#ffffff"/></g></svg>
        <svg v-if="icon.type === iconTypes.Exit" style="fill: rgb(100, 100, 100); pointer-events: auto;" :width="icon.iconSize" :height="icon.iconSize" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><title/><g data-name="1" id="_1"><path d="M27,3V29a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V27H7v1H25V4H7V7H5V3A1,1,0,0,1,6,2H26A1,1,0,0,1,27,3ZM10.71,20.29,7.41,17H18V15H7.41l3.3-3.29L9.29,10.29l-5,5a1,1,0,0,0,0,1.42l5,5Z" id="logout_account_exit_door"/></g></svg>
        <svg v-if="icon.type === iconTypes.Stairs"  style="fill: rgb(100, 100, 100); pointer-events: auto;" :width="icon.iconSize" :height="icon.iconSize" viewBox="0 0 439.752 365.145" id="svg1317" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:svg="http://www.w3.org/2000/svg"><defs id="defs1319"><marker id="ArrowEnd" markerHeight="3" markerUnits="strokeWidth" markerWidth="4" orient="auto" refX="0" refY="5" viewBox="0 0 10 10"><path d="M 0 0 L 10 5 L 0 10 z" id="path1322"/></marker><marker id="ArrowStart" markerHeight="3" markerUnits="strokeWidth" markerWidth="4" orient="auto" refX="10" refY="5" viewBox="0 0 10 10"><path d="M 10 0 L 0 5 L 10 10 z" id="path1325"/></marker></defs><g id="g1327"><path d="M 0 323.974L 80.05 323.974L 80.05 242.499L 159.584 242.499L 159.584 160.474L 240.373 160.474L 240.373 79.974L 320.614 79.974L 320.614 0L 439.752 0L 439.752 40.804L 360.55 40.804L 360.55 121.082L 280.218 121.082L 280.218 202.49L 200.05 202.49L 200.05 283.474L 119.55 283.474L 119.55 365.145L 0 365.145L 0 323.974z" id="path1329" style="stroke:none; fill:rgb(80, 80, 80)"/></g></svg>

        <g v-if="icon.type === iconTypes.Window">
          <rect :x="0" :y="-0.05" :width="icon.iconSize" :height="0.1"  style="fill: rgb(216 216 216); pointer-events: auto;"></rect>
          <rect :x="0" :y="-0.0125" :width="icon.iconSize" :height="0.025"  style="fill: rgb(180 180 180);; pointer-events: auto;"></rect>
        </g>
        <g v-if="icon.type === iconTypes.Door1">
          <rect :x="0" :y="-0.05" :width="icon.iconSize" :height="0.1"  style="fill: rgb(216 216 216); pointer-events: auto;"></rect>
          <rect :x="0" :y="-0.0125" :width="icon.iconSize" :height="0.025"  style="fill: rgb(180 180 180); pointer-events: auto;"></rect>
          <path style="stroke: rgb(170, 170, 170); fill: rgb(170 170 170 / 0%); stroke-width: 0.1; pointer-events: auto;" :d="'M 0 0 A ' + icon.iconSize + ' ' + icon.iconSize + ' 0 0 0 ' + icon.iconSize + ' ' + icon.iconSize + ' L ' + icon.iconSize + ' 0'"></path>
        </g>
        <g v-if="icon.type === iconTypes.Door2">
          <rect :x="0" :y="-0.05" :width="icon.iconSize" :height="0.1"  style="fill: rgb(216 216 216); pointer-events: auto;"></rect>
          <rect :x="0" :y="-0.0125" :width="icon.iconSize" :height="0.025"  style="fill: rgb(180 180 180); pointer-events: auto;"></rect>
          <path style="stroke: rgb(170, 170, 170); fill: rgb(170 170 170 / 0%); stroke-width: 0.1; pointer-events: auto;"
            :d="'M 0 0 L 0 ' + icon.iconSize/ 2
              + ' A ' + icon.iconSize / 2 + ' ' + icon.iconSize / 2 + ' 0 0 0 ' + icon.iconSize / 2 + ' ' + 0
              + ' A ' + icon.iconSize / 2 + ' ' + icon.iconSize / 2 + ' 0 0 0 ' + icon.iconSize + ' ' + icon.iconSize / 2
              + ' L ' + icon.iconSize + ' 0'"></path>
        </g>
      </g>

      <!--Pointer-->
      <circle :cx="currentMouseX" :cy="currentMouseY" :r="0.12" stroke="white" :stroke-width="0.04" :fill="getPinFill()" style="pointer-events: none;" />

      <!--Highlighter-->
      <g v-if="isEdit && drawMode.drawMode === drawModes.NONE" class="transition ease-in-out duration-300 transition-opacity" :class="{'opacity-0': !showHighlighter(), 'opacity-100': showHighlighter()}" ref="highlighter">
        <polygon :points="
            highlighterX + ',' + highlighterY + ' ' +
            (highlighterX + highlighterWidth) + ',' + highlighterY + ' ' +
            (highlighterX + highlighterWidth) + ',' + (highlighterY + highlighterHeight) + ' ' +
            highlighterX + ',' +  (highlighterY + highlighterHeight)"
          fill="none"
          stroke="#0074d9"
          stroke-width="0.1"
          stroke-linejoin="round"/>
        <g v-if="isEdit" :style="'transform: translate('+ getHighlighterButtonPosition() +') rotate(' + getHighlighterButtonRotation() + ');'" @mouseover="isMouseOver = true" @mouseleave="isMouseOver = false">
          <svg version="1.1" id="Layer_1" width="0.5" height="0.5"
              viewBox="0 0 24 24"  style="overflow:auto;"  @mouseover="isMouseOver = true" @mouseleave="isMouseOver = false" @click="deleteButtonClick()">
            <rect  fill="#2D2D2D" stroke="#2D2D2D" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" x="1" y="1" class="st0" width="22.1" height="22.1"/>
            <polyline fill="none" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="st1" points="4,6.6 5.7,6.6 20,6.6 "/>
            <path fill="none" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="st1" d="M18.3,6.6v12.5c0,1-0.8,1.8-1.8,1.8H7.5c-1,0-1.8-0.8-1.8-1.8V6.6 M8.4,6.6V4.8c0-1,0.8-1.8,1.8-1.8h3.6
              c1,0,1.8,0.8,1.8,1.8v1.8"/>
            <line fill="none" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" x1="10.2" y1="11.1" x2="10.2" y2="16.5"/>
            <line fill="none" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" x1="13.8" y1="11.1" x2="13.8" y2="16.5"/>
          </svg>

          <svg version="1.1" id="Layer_1" width="0.5" height="0.5" x="0.65"
              viewBox="0 0 24 24"  style="overflow:auto;" @mouseover="isMouseOver = true" @mouseleave="isMouseOver = false" @click="moveButtonClick()">
            <rect fill="#2D2D2D" stroke="#2D2D2D" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" x="1" y="1" class="st0" width="22.1" height="22.1"/>
            <polyline stroke="#FFFFFF" points="5 9 2 12 5 15"></polyline>
            <polyline stroke="#FFFFFF" points="9 5 12 2 15 5"></polyline>
            <polyline stroke="#FFFFFF" points="15 19 12 22 9 19"></polyline>
            <polyline stroke="#FFFFFF" points="19 9 22 12 19 15"></polyline>
            <line stroke="#FFFFFF" x1="2" y1="12" x2="22" y2="12"></line>
            <line stroke="#FFFFFF" x1="12" y1="2" x2="12" y2="22"></line>
          </svg>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>

import { BOOKING_STATE, ARRIVAL_STATE } from '@/store/modules/marcom/data-model/bookings';
import { mapGetters } from "vuex";
import { Floorplan, Polygon, Point, FloorplanWall, FloorplanTable, BoundingBox, FloorplanLabel, FloorplanIconType, FloorplanObject } from '@/store/modules/marcom/data-model/floorplan/floorplan.js';
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

const drawModes = {
	NONE: "none",
	SECTION: "section",
  TABLE: "table",
  TEXT: "text",
  DELETE: "delete",
  ICON: "icon"
}

export default {
  props: {
    isEdit:Boolean,
    leftOffset:Number
  },
  components:{
  },
  data() {
    return {
      drawModes: drawModes,
      seatingGap: 0.75,
      isMouseDown: false,
      isPanning: false,
      canvas: null,
      scale:20,
      scaleBg:20,
      buttonSize:10,
      transformX:500,
      transformY:500,
      mouseDownX:null,
      mouseDownY:null,
      lastMouseX:null,
      lastMouseY:null,
      currentMouseX:null,
      currentMouseY:null,
      polygons:[],
      dividers:[],
      tables:[],
      labels:[],
      icons:[],
      svg:null,
      svgPt:null,
      svgBg:null,
      svgPtBg:null,
      drawMode: this.getNoDrawMode(),
      iconTypes: new FloorplanIconType(),
      highlighterWidth:0,
      highlighterHeight:0,
      highlighterX:0,
      highlighterY:0,
      highlighterTransform:null,
      isMouseOver: false,
      highlighterRotation: 0,
      highlighterObject: null

    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userId: "users/userId",
    })
  },
  mounted() {
    this.svg = this.$refs["canvasSvg"];
    this.svgPt = this.svg.createSVGPoint();
    this.svgBg = this.$refs["canvasSvgBg"];
    this.svgPtBg = this.svg.createSVGPoint();
    var self = this;
    window.addEventListener('keyup', function(event) {
      if (event.code === 'Enter' && event.type === 'keyup') {
        self.onEnter();
      }
      if (event.code === 'Escape' && event.type === 'keyup') {
        self.onEscape();
      }
      if (event.code === 'KeyR' && event.type === 'keyup' && self.drawMode.drawMode !== drawModes.TEXT) {
        self.onRotate();
      }
    });
  },
  methods: {
    onZoom() {

      var holder = this.$refs.holder;

      //The total dimension is based on the width of the screen!
      var holderWidth = holder.offsetWidth;
      this.$emit('onZoom', (holderWidth / 1000) * this.scale)
    },
    onWheel(event){
      var cursorPointBefore = this.getCursorPointBg(event);
      var scale =  Math.max(Math.min(this.scale - event.deltaY/100, 64), 0.5);
      this.scaleBg = scale;

      setTimeout(() => {
        var cursorPointAfter = this.getCursorPointBg(event);
        this.transformX += (cursorPointBefore.x - cursorPointAfter.x) * scale;
        this.transformY += (cursorPointBefore.y - cursorPointAfter.y) * scale;
        this.scale = scale;
        this.onZoom();
      }, 0);

    },
    onMousedown(event){
      this.isMouseDown = true;
      this.mouseDownX = event.screenX;
      this.mouseDownY = event.screenY;
    },
    onMouseup(event){
      var cursorPoint = this.getCursorPoint(event);

      if (!this.isPanning) {
        if (this.drawMode.drawMode === drawModes.SECTION) {
          this.drawMode.isDrawing = true;

          var current = {
            svgPoint: cursorPoint.x + "," + cursorPoint.y,
            x:cursorPoint.x,
            y:cursorPoint.y
          };

          //Check if we are at the start of the polygon
          if (this.drawMode.polygon && this.drawMode.polygon.points && this.drawMode.polygon.points.length > 2 && this.drawMode.polygon.points[0].svgPoint == current.svgPoint) {
            this.polygons.push(this.drawMode.polygon);
            this.drawMode.isDrawing = false;
            this.drawMode.polygon = null;
          }
          else {
            if (!this.drawMode.polygon) {
              this.drawMode.polygon = {
                points: [current],
                sectionId: this.drawMode.currentDrawingSection.id
              };
            }

            this.drawMode.polygon.points.push(current);
          }
          this.$emit('onDrawing', this.drawMode.polygon);

        }
        else if (this.drawMode.drawMode !== drawModes.SECTION && this.drawMode.drawMode !== drawModes.DELETE) {
          this.drawMode.drawMode = drawModes.NONE;
          this.$emit('onEscape');
        }
      }

      this.isMouseDown = false;
      this.isPanning = false;

      this.lastMouseX = null;
      this.lastMouseY = null;
    },
    onMousemove(event){
      var cursorPoint = this.getCursorPoint(event);

      if (this.isMouseDown) {
        //Determin if we are panning
        if (!this.isPanning) {
          var deltaX = event.screenX - this.mouseDownX;
          var deltaY = event.screenY - this.mouseDownY;

          if (Math.abs(deltaX) > 2 || Math.abs(deltaY) > 2)
            this.isPanning = true;
        }

        if (this.lastMouseX && this.lastMouseY) {
          this.transformX -= (event.screenX - this.lastMouseX);
          this.transformY -= (event.screenY - this.lastMouseY);
        }

        this.lastMouseX = event.screenX;
        this.lastMouseY = event.screenY;
      }
      else if (this.drawMode.drawMode == drawModes.SECTION) {
        if (this.drawMode.isDrawing) {

          var current = {
            svgPoint: cursorPoint.x + "," + cursorPoint.y,
            x:cursorPoint.x,
            y:cursorPoint.y,
          };

          this.drawMode.polygon.points[this.drawMode.polygon.points.length - 1] = current;
        }
      }
      else if (this.drawMode.drawMode == drawModes.TABLE) {
        this.drawMode.svgTable.x = cursorPoint.x;
        this.drawMode.svgTable.y = cursorPoint.y;
      }
      else if (this.drawMode.drawMode == drawModes.TEXT) {
        this.drawMode.currentDrawingText.x = cursorPoint.x;
        this.drawMode.currentDrawingText.y = cursorPoint.y;
      }
      else if (this.drawMode.drawMode == drawModes.ICON) {
        this.drawMode.currentDrawingIcon.x = cursorPoint.x;
        this.drawMode.currentDrawingIcon.y = cursorPoint.y;
      }

      this.currentMouseX = cursorPoint.x;
      this.currentMouseY = cursorPoint.y;
    },
    onEnter() {
      if (this.drawMode.drawMode == drawModes.SECTION && this.drawMode.isDrawing && this.drawMode.polygon.points.length > 2) {
        this.dividers.push(this.drawMode.polygon.points.splice(0, this.drawMode.polygon.points.length - 1))
      }
    },
    onEscape() {
        this.drawMode = this.getNoDrawMode();
        this.$emit('onEscape');
    },
    onRotate() {
      if (this.drawMode.drawMode === drawModes.TABLE) {
        this.drawMode.svgTable.rotation = (this.drawMode.svgTable.rotation + 45) % 360;
      }
      if (this.drawMode.drawMode === drawModes.TEXT) {
        this.drawMode.currentDrawingText.rotation = (this.drawMode.currentDrawingText.rotation + 45) % 360;
      }
      if (this.drawMode.drawMode === drawModes.ICON) {
        this.drawMode.currentDrawingIcon.rotation = (this.drawMode.currentDrawingIcon.rotation + 45) % 360;
      }

    },
    getCursorPoint(event) {
      var snapFrequency = (this.drawMode.drawMode == drawModes.TEXT || this.drawMode.drawMode == drawModes.ICON) ? 0.25 : 0.5;
      this.svgPt.x = event.clientX;
      this.svgPt.y = event.clientY;

      // The cursor point, translated into svg coordinates
      var ret =  this.svgPt.matrixTransform(this.svg.getScreenCTM().inverse());

      ret.x = Math.round(ret.x / snapFrequency) * snapFrequency;
      ret.y = Math.round(ret.y / snapFrequency) * snapFrequency;

      return ret;
    },
    getCursorPointBg(event) {
      this.svgPtBg.x = event.clientX;
      this.svgPtBg.y = event.clientY;

      // The cursor point, translated into svg coordinates
      var ret =  this.svgPtBg.matrixTransform(this.svgBg.getScreenCTM().inverse());
      return ret;
    },
    getPinFill() {
      if (this.drawMode.drawMode == drawModes.DELETE) {
        return 'rgb(240, 103, 115)';
      }
      else {
        return this.drawMode.drawMode === drawModes.SECTION || this.drawMode.drawMode === drawModes.TABLE ? 'rgb(68 161 185)' : 'rgb(160, 160, 180)'
      }
    },
    isDelete() {
      return this.drawMode && this.drawMode.drawMode == drawModes.DELETE;
    },
    toggleSectionDrawing(section) {
      if (this.drawMode.currentDrawingSection == section) {
        this.drawMode = this.getNoDrawMode();
      }
      else {
        this.drawMode = {
          currentDrawingSection: section,
          drawMode: drawModes.SECTION
        }
      }
    },
    toggleTextDrawing(text) {
      if (this.drawMode.currentDrawingText == text) {
        this.drawMode = this.getNoDrawMode();
      }
      else {
        text.x = this.currentMouseX != null ? this.currentMouseX : 0,
        text.y = this.currentMouseY != null ? this.currentMouseY : 0,
        this.drawMode = {
          currentDrawingText: text,
          drawMode: drawModes.TEXT,
        }

        this.labels.push(text);
      }
    },
    toggleIconDrawing(icon) {
      if (this.drawMode.currentDrawingIcon == icon) {
        this.drawMode = this.getNoDrawMode();
      }
      else {
        icon.x = this.currentMouseX != null ? this.currentMouseX : 0,
        icon.y = this.currentMouseY != null ? this.currentMouseY : 0,
        icon.rotation = 0;
        this.drawMode = {
          currentDrawingIcon: icon,
          drawMode: drawModes.ICON,
        }

        this.icons.push(icon);
      }
    },
    toggleTableDrawing(table) {
      if (this.currentDrawingTable == table) {
        this.drawMode = this.getNoDrawMode();
      }
      else {
        //Check if we have the table already
        var existing = this.tables.find(t => t.table.id === table.id)

        if (existing) {
          existing.hidden = false;
          this.drawMode = {
            currentDrawingTable: table,
            drawMode: drawModes.TABLE,
            svgTable: existing
          }
        }
        else {
          this.drawMode = {
            currentDrawingTable: table,
            drawMode: drawModes.TABLE,
            svgTable: this.getTableSvg(table, 0)
          }
          this.tables.push(this.drawMode.svgTable);
        }
      }
    },
    toggleDelete() {
      if (this.drawMode.drawMode === drawModes.DELETE) {
        this.drawMode = this.getNoDrawMode();
      }
      else {
        this.drawMode = {
          drawMode: drawModes.DELETE,
        }
      }
    },
    deletePolygon(polygon) {
      if (this.drawMode.drawMode === drawModes.DELETE)
        this.polygons.splice(this.polygons.indexOf(polygon), 1);
    },
    deleteText(text) {
      if (this.drawMode.drawMode === drawModes.DELETE)
        this.labels.splice(this.labels.indexOf(text), 1);
    },
    deleteDivider(divider) {
      if (this.drawMode.drawMode === drawModes.DELETE)
        this.dividers.splice(this.dividers.indexOf(divider), 1);
    },
    clickTable(table) {
      if (this.drawMode.drawMode === drawModes.DELETE) {
        table.hidden = true;
          this.$emit('onTableDeleted', table);
      }
      else if (table.table.booking) {
          this.$emit('onBookingClick', table.table.booking);
      }
      else {
        this.$emit('onTableClick', table);
      }
    },
    deleteIcon(icon) {
      if (this.drawMode.drawMode === drawModes.DELETE)
        this.icons.splice(this.icons.indexOf(icon), 1);
    },
    elementMouseOver(event, rotation, object) {
      this.highlighterObject = object;
      this.isMouseOver = true;

      var bBox = event.currentTarget.getBBox();

      this.highlighterWidth = bBox.width;
      this.highlighterHeight = bBox.height;
      this.highlighterX = bBox.x;
      this.highlighterY = bBox.y;
      this.highlighterRotation = rotation;
      if (this.$refs.highlighter)
        this.$refs.highlighter.setAttribute("transform", event.currentTarget.getAttribute("transform"));
    },
    deleteButtonClick() {
      if (!this.isEdit || this.drawMode.drawMode !== drawModes.NONE)
        return;
      if (this.highlighterObject.table) {
        this.highlighterObject.hidden = true;
        this.$emit('onTableDeleted', this.highlighterObject);
        this.disableHighlighter();
      }
      else if (this.highlighterObject.text) {
        this.labels.splice(this.labels.indexOf(this.highlighterObject), 1);
        this.disableHighlighter();
      }
      if (this.highlighterObject.type) {
        this.icons.splice(this.icons.indexOf(this.highlighterObject), 1);
        this.disableHighlighter();
      }
    },
    moveButtonClick() {
      if (!this.isEdit || this.drawMode.drawMode !== drawModes.NONE)
        return;
      if (this.highlighterObject.table) {
        this.toggleTableDrawing(this.highlighterObject.table)
        this.isMouseOver = false;
      }
      else if (this.highlighterObject.text) {
        this.drawMode = {
          currentDrawingText: this.highlighterObject,
          drawMode: drawModes.TEXT,
        }
      }
      else if (this.highlighterObject.type) {
        this.drawMode = {
          currentDrawingIcon: this.highlighterObject,
          drawMode: drawModes.ICON,
        }
      }

      this.$emit('onMoveButtonClicked', this.highlighterObject);
    },
    disableHighlighter() {
      this.isMouseOver = false;
      this.highlighterX = 0;
      this.highlighterY = 0;
      this.highlighterWidth = 0;
      this.highlighterHeight = 0;
      this.$refs.highlighter.setAttribute("transform", "");
    },
    elementMouseLeave(event) {
      this.isMouseOver = false;
    },
    showHighlighter() {
      return this.isEdit && this.isMouseOver && this.drawMode.drawMode === drawModes.NONE;
    },
    getHighlighterButtonPosition() {
      if (this.highlighterRotation >= 180)
        return "1.5px, 0.5px"
      return "0.5px, -0.25px";
    },
    getHighlighterButtonRotation() {
      return this.highlighterRotation >= 180 ? "-180deg" : "0deg"
    },
    getNoDrawMode() {
      return{
        drawMode: drawModes.NONE,

        isDrawing:false,
        polygon:null,
        currentDrawingSection:null,

        currentDrawingTable:null,
        currentDrawingText:null,
      }
    },
    getTableSvg(table, rotation) {
      var seats = this.getTableSvgSeats(table);

      return {
        width: this.getTableWidth(table),
        height: this.getTableHeight(table),
        x: this.currentMouseX != null ? this.currentMouseX : 0,
        y: this.currentMouseY != null ? this.currentMouseY : 0,
        seats,
        table:table,
        rotation:rotation,
        status:this.getTableStatus(table),
        hidden: false,
        isRoundTable: table.isRoundTable
      }
    },
    getTableWidth(table, isRotated = false) {
      if (table.isRoundTable)
        return table.seatCount * this.seatingGap/Math.PI;
      else
        return isRotated ? this.seatingGap : Math.ceil(table.seatCount / 2) * this.seatingGap;
    },
    getTableHeight(table, isRotated = false) {
      if (table.isRoundTable)
        return table.seatCount * this.seatingGap/Math.PI;
      else
        return isRotated ? Math.ceil(table.seatCount / 2) * this.seatingGap : this.seatingGap;
    },
    getTableSvgSeats(table, isRotated = false) {
      var seats = [];
      if (table.isRoundTable) {
        var radius = (table.seatCount * this.seatingGap/Math.PI) / 2;
        for (let index = 0; index < table.seatCount; index++) {
          var radian = 2 * Math.PI * (index / table.seatCount);
          let x = Math.cos(radian) * radius;
          let y = Math.sin(radian) * radius;
          seats.push({
            x:x,y:y
          });
        }
      }
      else {
        var seatsLeft = Math.ceil(table.seatCount / 2);
        for (let index = 0; index < seatsLeft; index++) {
          let x = index * this.seatingGap + 0.5 * this.seatingGap;
          if (isRotated) {
            seats.push({
              x:0,y:x
            });
            seats.push({
              x:this.seatingGap,y:x
            });
          }
          else {
            seats.push({
              x,y:0
            });
            seats.push({
              x,y: this.seatingGap
            });
          }
        }
        if (seats.length > table.seatCount)
          seats.pop();
      }


      return seats;
    },
    setFloorplanModel(floorplanModel) {
      this.polygons.push(...floorplanModel.entities.filter(i => i.itemType == "FloorplanWall" && i.points.closedShape).map(
        i => {
          return {
            sectionId: i.sectionId,
            points: i.points.points.map(p => {
              return {
                svgPoint: p.x + "," + p.y,
                x:p.x,
                y:p.y
              }})
          }
        }
      ));
      this.dividers.push(...floorplanModel.entities.filter(i => i.itemType == "FloorplanWall" && !i.points.closedShape).map(
        i => {
          return i.points.points.map(p => {
            return {
              svgPoint: p.x + "," + p.y,
              x:p.x,
              y:p.y
            }
          })
        }
      ));
      this.labels.push(...floorplanModel.entities.filter(i => i.itemType == "FloorplanLabel").map(
        i => {
          return {
            x: i.location.x, y: i.location.y, rotation:i.rotation, text: i.label.text, fontSize:i.label.fontSize
          }
        }
      ));
      this.icons.push(...floorplanModel.entities.filter(i => i.itemType == "FloorplanObject").map(
        i => {
          return {
            type:i.icon.icon,
            x:i.icon.location.x,
            y:i.icon.location.y,
            rotation:i.icon.rotation,
            iconSize:i.icon.scale,

          }
        }
      ));
      this.tables.push(...floorplanModel.tables.filter(i => i.itemType == "RegularTable").map(
        t => {
          return {
            width: this.getTableWidth({seatCount: t.seatCount, isRoundTable: t.isRoundTable}),
            height: this.getTableHeight({seatCount: t.seatCount}),
            x: t.location.upperLeftCorner.x,
            y: t.location.upperLeftCorner.y,
            seats: this.getTableSvgSeats({seatCount: t.seatCount, isRoundTable: t.isRoundTable}),
            table:{id:t.tableId, name: t.name, seatCount:t.seatCount, booking: t.booking, discardedBooking: t.discardedBooking, note: t.note, isRoundTable: t.isRoundTable},
            rotation:t.rotation,
            status:this.getTableStatus(t),
            hidden: t.hidden
          }
        }
      ));

      this.zoomToContent();
    },
    getFloorplanModel() {
      var entities = [];

      entities.push(...this.polygons.map(p => {
        return new FloorplanWall(1, new Polygon(p.points.map(point => new Point(point.x, point.y)), true), p.sectionId)
      }));
      entities.push(...this.dividers.map(p => {
        return new FloorplanWall(1, new Polygon(p.map(point => new Point(point.x, point.y)), false), "")
      }));
      entities.push(...this.labels.map(t => {
        return new FloorplanLabel(new Point(t.x, t.y), t.rotation, t.text, t.fontSize)
      }));
      entities.push(...this.icons.map(i => {
        return new FloorplanObject(i.type, new Point(i.x, i.y), i.iconSize, i.rotation)
      }));

      var tables = [];
      tables.push(...this.tables.map(t => {
        return new FloorplanTable(t.table.id, t.table.seatCount, new BoundingBox(new Point(t.x, t.y), new Point(t.x + t.width, t.y + t.height)), t.rotation, t.hidden)
      }));

      var floorplan = new Floorplan(entities, tables)

      return floorplan;
    },
    getTableStatus(table) {
      if (this.isEdit) {
        return {
          color: "rgb(100 100 100)",
          subLabel:null
        }
      }
      else if (!table.isActive) {
        return {
          color: "rgb(100 100 100)",
          subLabel:null
        }
      }
      else if (!table.booking) {
        if (!table.isReservedForWalkIns)
          return {
            color: "rgb(80 170 70)",
            subLabel:null
          }
        else
          return {
            color: "rgb(133 48 149)",
            subLabel:null
          }
      }
      else {
        var subLabel = moment(table.booking.booking.arrival).format("HH:mm");

        var deadline = new Date(new Date(table.booking.booking.arrival).getFullYear(), new Date(table.booking.booking.arrival).getMonth(), new Date(table.booking.booking.arrival).getDate(), new Date(table.booking.booking.arrival).getHours(), new Date(table.booking.booking.arrival).getMinutes() + 5);
        var color = "rgb(100 100 100)";
        var isOvertime = new Date() > deadline;

        switch (table.booking.booking.bookingState) {
          case BOOKING_STATE.Reserved:
            color = "rgb(255 80 70)";
            break;
          case BOOKING_STATE.GuestConfirmed:
          case BOOKING_STATE.VenueConfirmed:
            color = "rgb(255 80 70)";

            switch(table.booking.booking.arrivalState) {
              case ARRIVAL_STATE.NotArrived:
                color = isOvertime ?  "rgb(200 80 70)" : "rgb(255 80 70)";
                subLabel = isOvertime ? "Overtime " + subLabel : subLabel;
                break;
              case ARRIVAL_STATE.Seated:
                color = "rgb(255 150 150)";
                subLabel = "Seated";
                break;
              case ARRIVAL_STATE.Delayed:
                color = "rgb(255 80 70)";
                subLabel = isOvertime ? "Delayed " + subLabel : subLabel;
                break;
              case ARRIVAL_STATE.NoShow:
                color = "rgb(80 170 70)";
                subLabel = null;
                break;
            }
            break;
          case BOOKING_STATE.Requested:
            color = "rgb(255 150 150)";
            break;
          case BOOKING_STATE.RequestRejected:
          case BOOKING_STATE.CancelledVenue:
          case BOOKING_STATE.CancelledGuest:
            color = "rgb(80 170 70)";
            subLabel = null
            break;
        }
      }

      return { subLabel, color };

    },
    zoomToTable(tableId) {
      if (this.tables == null)
        return;

      var tableElement = this.tables.find(t => t.table.id === tableId);
      if (tableElement == null || tableElement.hidden)
        return;

      var vWidthX = Math.cos(tableElement.rotation * (Math.PI/180)) * tableElement.width;
      var vWidthY =  Math.sin(tableElement.rotation * (Math.PI/180)) * tableElement.width;

      var vHeightX = -Math.sin(tableElement.rotation * (Math.PI/180)) * tableElement.height;
      var vHeightY = Math.cos(tableElement.rotation * (Math.PI/180)) * tableElement.height;

      this.zoomToPolygons([
        {
          points: [
            {
              x: tableElement.x + vWidthX * 0.5 + vHeightX * 0.5 - 0.5,
              y: tableElement.y + vWidthY * 0.5 + vHeightY * 0.5 - 0.5,
            },
            {
              x: tableElement.x + vWidthX * 0.5 + vHeightX * 0.5 + 0.5,
              y: tableElement.y + vWidthY * 0.5 + vHeightY * 0.5 - 0.5,
            },
            {
              x: tableElement.x + vWidthX * 0.5 + vHeightX * 0.5 + 0.5,
              y: tableElement.y + vWidthY * 0.5 + vHeightY * 0.5 + 0.5,
            },
            {
              x: tableElement.x + vWidthX * 0.5 + vHeightX * 0.5 - 0.5,
              y: tableElement.y + vWidthY * 0.5 + vHeightY * 0.5 + 0.5,
            }
          ]
        }
      ])
    },
    zoomToSection(sectionId) {
      var sectionPolygons = this.polygons.filter(p => p.sectionId === sectionId)

      if (sectionPolygons.length > 0)
        this.zoomToPolygons(sectionPolygons)
    },
    zoomToContent() {
      this.zoomToPolygons(this.polygons);
    },
    zoomToPolygons(polygons) {
      if (polygons.length === 0) {
        this.transformX = 500;
        this.transformY = 500;
        this.scale = 40;
        this.onZoom();
        return;
      }

      //Find boundingBox of content
      var minX = Number.MAX_VALUE;
      var minY = Number.MAX_VALUE;
      var maxX = Number.MIN_VALUE;
      var maxY = Number.MIN_VALUE;
      polygons.forEach(p => {
        p.points.forEach(point => {
          if (point.x < minX)
            minX = point.x;
          if (point.x > maxX)
            maxX = point.x;
          if (point.y < minY)
            minY = point.y;
          if (point.y > maxY)
            maxY = point.y;
        })
      })

      //Center of content bounding box
      var centerX = minX + ((maxX - minX) / 2);
      var centerY = minY + ((maxY - minY) / 2);

      var holder = this.$refs.holder;

      //The total dimension is based on the width of the screen!
      var holderWidth = holder.offsetWidth;
      var holderHeight = holder.offsetHeight;
      var totalDim = holderWidth;

      //Find center of canvas
      var offsetY = (holderHeight - totalDim) / 2;
      var offsetX = (holderWidth - totalDim) / 2;

      //Find scale
      var contentWidth = ((maxX - minX) / 1000)  * (holderWidth / (holderWidth - this.leftOffset)); //If we have left offset we should scale
      var contentHeight = ((maxY - minY) / 1000) * (holderWidth / holderHeight); //Scale is determined by width of screen, we need to scale by aspect
      var contentDimRate = Math.max(contentWidth, contentHeight);
      this.scale = Math.min(50, Math.floor(1/contentDimRate - 2));
      this.scaleBg = this.scale;

      var centerOffsetX = (centerX - 500) * (totalDim / 1000) * this.scale ;
      var centerOffsetY = (centerY - 500) * (totalDim / 1000) * this.scale ;

      offsetX -= centerOffsetX - this.leftOffset / 2;
      offsetY -= centerOffsetY;

      this.transformX = -offsetX;
      this.transformY = -offsetY;

      this.onZoom();
    },
    
    onTouchStart(event){
      event.screenX = event.touches["0"].screenX
      event.screenY = event.touches["0"].screenY
      this.isMouseDown = true;
      this.mouseDownX = event.screenX;
      this.mouseDownY = event.screenY;
    },

    onTouchEnd(event){
      event.screenX = event.changedTouches["0"].screenX
      event.screenY = event.changedTouches["0"].screenY
      event.clientX = event.changedTouches["0"].clientX
      event.clientY = event.changedTouches["0"].clientY
      var cursorPoint = this.getCursorPoint(event);

      if (!this.isPanning) {
        if (this.drawMode.drawMode === drawModes.SECTION) {
          this.drawMode.isDrawing = true;

          var current = {
            svgPoint: cursorPoint.x + "," + cursorPoint.y,
            x:cursorPoint.x,
            y:cursorPoint.y
          };

          //Check if we are at the start of the polygon
          if (this.drawMode.polygon && this.drawMode.polygon.points && this.drawMode.polygon.points.length > 2 && this.drawMode.polygon.points[0].svgPoint == current.svgPoint) {
            this.polygons.push(this.drawMode.polygon);
            this.drawMode.isDrawing = false;
            this.drawMode.polygon = null;
          }
          else {
            if (!this.drawMode.polygon) {
              this.drawMode.polygon = {
                points: [current],
                sectionId: this.drawMode.currentDrawingSection.id
              };
            }

            this.drawMode.polygon.points.push(current);
          }
          this.$emit('onDrawing', this.drawMode.polygon);

        }
        else if (this.drawMode.drawMode !== drawModes.SECTION && this.drawMode.drawMode !== drawModes.DELETE) {
          this.drawMode.drawMode = drawModes.NONE;
          this.$emit('onEscape');
        }
        else if (this.drawMode.drawMode == drawModes.TABLE) {
     
        this.drawMode.svgTable.x = cursorPoint.x;
        this.drawMode.svgTable.y = cursorPoint.y;
        }
      }

      this.isMouseDown = false;
      this.isPanning = false;

      this.lastMouseX = null;
      this.lastMouseY = null;
    },

    onTouchmove(event){

      event.screenX = event.touches["0"].screenX
      event.screenY = event.touches["0"].screenY
      event.clientX = event.touches["0"].clientX
      event.clientY = event.touches["0"].clientY

      var cursorPoint = this.getCursorPoint(event);

      if (this.isMouseDown) {
        //Determin if we are panning
        if (!this.isPanning) {
          var deltaX = event.screenX - this.mouseDownX;
          var deltaY = event.screenY - this.mouseDownY;

          if (Math.abs(deltaX) > 2 || Math.abs(deltaY) > 2 || event.touches.length > 1)
            this.isPanning = true;
        }

        if (this.lastMouseX && this.lastMouseY) {
          this.transformX -= (event.screenX - this.lastMouseX);
          this.transformY -= (event.screenY - this.lastMouseY);
        }

        this.lastMouseX = event.screenX;
        this.lastMouseY = event.screenY;
      }
      else if (this.drawMode.drawMode == drawModes.SECTION) {
        if (this.drawMode.isDrawing) {

          var current = {
            svgPoint: cursorPoint.x + "," + cursorPoint.y,
            x:cursorPoint.x,
            y:cursorPoint.y,
          };

          this.drawMode.polygon.points[this.drawMode.polygon.points.length - 1] = current;
        }
      }
      else if (this.drawMode.drawMode == drawModes.TABLE) {
     
        this.drawMode.svgTable.x = cursorPoint.x;
        this.drawMode.svgTable.y = cursorPoint.y;
      }
      else if (this.drawMode.drawMode == drawModes.TEXT) {
        this.drawMode.currentDrawingText.x = cursorPoint.x;
        this.drawMode.currentDrawingText.y = cursorPoint.y;
      }
      else if (this.drawMode.drawMode == drawModes.ICON) {
        this.drawMode.currentDrawingIcon.x = cursorPoint.x;
        this.drawMode.currentDrawingIcon.y = cursorPoint.y;
      }

      this.currentMouseX = cursorPoint.x;
      this.currentMouseY = cursorPoint.y;
    }
  },
};
</script>

<style style="scss" scoped>
.deleting .polygon:hover {
  fill: rgba(255 0 0 / 20%) !important;
}
.deleting .text:hover {
  fill: rgba(255 0 0 / 80%) !important;
}
.deleting .divider:hover {
  stroke: rgba(255 0 0 / 80%) !important;
}
.deleting .table-polygon:hover {
  fill: rgba(255 0 0 / 20%) !important;
}
.deleting .icon-group svg:hover, .deleting .icon-group path:hover {
  fill: rgba(255 0 0 / 80%) !important;
}
</style>
